import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  gap: '0 20rem',

  [theme.breakpoint.media.max.md]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15rem',
  },
}));

export const Item = styled.div({
  position: 'relative',
  flex: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const Separator = styled.div(({ theme }) => ({
  width: '50%',
  border: `1px solid ${theme.palette.darkLiver}`,
  position: 'absolute',
  top: '30px',
  right: 0,
  transform: 'translateX(50%)',

  '@media(max-width: 991px)': {
    width: '25%',
  },

  [theme.breakpoint.media.max.md]: {
    display: 'none',
  },
}));
